export default {
  components: {},
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    getUri() {
      return null
    },
    indexUri() {
      return null
    },
    _storeId() {
      return _.isArray(this.storeId) ? [...this.storeId] : [this.storeId]
    },
    store() {
      return {
        getter: (keys, _default) => {
          let value = this.$util.getObjectVal(this.$store.getters.data, [...this._storeId.concat(keys)])
          if (_.isObjectLike(value) && _.isObjectLike(_default)) {
            value = _.mergeLeft(_default, value)
          } else if (value == null && !_.isUndefined(_default)) {
            value = _default
          }
          return value
        },
        commit: (keys, payload) => {
          this.$store.commit('SET_DATA', {
            keys: this._storeId.concat(keys),
            value: payload
          })
        }
      }
    }
  },
  mounted() {
    this.initialization()
  },
  methods: {
    initialization() {
      if (_.isString(this.indexUri || this.getUri) && String(this.indexUri || this.getUri).length > 0) {
        this.fetchData(
          {},
          {
            preload: this.preload || false
          }
        )
      }
    },
    async fetchData(data, args) {
      args = Object.assign(
        {
          preload: false,
          $el: this?.config?.$el || this.$el,
          force: true
        },
        args
      )

      if (!_.isObjectLike(data)) {
        data = {}
      }

      try {
        const response = await this.$util.get(this.indexUri || this.getUri, data, args.$el, null, {}, args)
        this.setUpData(response, data)
      } catch (error) {
        this.$util.captureException(error, data, 'error')
      }
    },
    async submitForm(data, callback, args) {
      let $el = null
      if (this.$el) {
        $el = this.$el.nodeName != '#text' ? this.$el : this.$el.parentNode
        if ($el.querySelector('.modal-content')) {
          $el = $el.querySelector('.modal-content')
        } else {
          $el = $el.closest('.modal-content')
        }
      }
      if (window.uploading > 0 && !window.confirm('Some processes are not completed. Do you want to continue?')) {
        window.uploading = 0
        return
      }
      args = Object.assign(
        {
          preload: false,
          $el
        },
        args
      )
      if (!_.isObjectLike(data)) {
        data = {}
      }
      if (_.isObjectLike(this.submitStructure)) {
        data = this.only(this.submitStructure, data)
      }

      try {
        const response = await this.$util.request(this.submitUri, data, args.$el, null, {}, args)
        if (_.isFunction(callback?.done)) {
          callback.done(response)
        } else if (_.isFunction(callback)) {
          callback(response)
        }
      } catch (error) {
        if (_.isFunction(callback?.error)) {
          callback.error(error)
        }
        this.$util.captureException(error, data, 'error')
      } finally {
        if (_.isFunction(callback?.finally)) {
          callback.finally()
        }
      }
    },
    only(structure, object) {
      return this.$util.only(structure, object)
    }
  }
}
